import { getLocalizaciones } from "@/api/localizaciones.api.js"

const state = {

    localizacion: [],
    idiomas: [],
    curso: {}

}

const getters = {

    /**
     * Return localizacion
     * 
     */

    getLocalizacion(state) {

        return state.localizacion

    },

    /**
     * Return the idioma name by code
     * 
     */
    getIdiomasCode: (state) => (code) => {

        let idioma = state.idiomas.filter(function(idioma){
            return idioma.idioma.id == code
        })

        return idioma[0].idioma.codigoTraduccion

    },

    /**
     * Return all idiomas exlude the one with *
     * 
     */
    getIdiomasFront(state) {

        return state.idiomas.filter(function(idioma){
            return idioma.idioma.id != 1
        })

    },

    /**
     * Return curso
     * 
     */

    getCurso(state) {

        return state.curso

    },

}

const actions = {

    /**
     * Fetch localizacion segun el subdominio desde el que accede
     * 
     */

    async fetchLocalizacion({ commit }, slug) {

        try {

            const response = await getLocalizaciones(slug)

            commit('SET_LOCALIZACION', response.data)
            commit('SET_IDIOMAS', response.data[0].idiomas)
            commit('SET_CURSO', response.data[0].ultimoCurso)

        } catch (error) {

            console.log(error)

        }    

    }

}

const mutations = {

    /**
     * Add localizacion al estado
     * 
     */
    
     SET_LOCALIZACION(state, data) {

        state.localizacion = data

    },

    /**
     * Add idiomas al estado
     * 
     */
    
     SET_IDIOMAS(state, data) {

        state.idiomas = data

    },

    /**
     * Add curso al estado
     * 
     */
    
     SET_CURSO(state, data) {

        state.curso = data

    }

}

export default {

    namespaced: true,
    state,
    getters,
    actions,
    mutations
    
}
